import Api from '../../../../../../shared/Api';

export class DigitalStylingOrderListApi {
    static async getDigitalStylingOrders() {
        return new Api().get(`/views/orders-list/digital-styling`);
    }
}